import { render, staticRenderFns } from "./SectionTableServices.vue?vue&type=template&id=962959a6&scoped=true&"
import script from "./SectionTableServices.vue?vue&type=script&lang=js&"
export * from "./SectionTableServices.vue?vue&type=script&lang=js&"
import style0 from "./SectionTableServices.vue?vue&type=style&index=0&id=962959a6&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962959a6",
  null
  
)

export default component.exports